import { useState } from "react";
import useSubmitSignature from '../../requests/useSubmitSignature';
import DeviceOrientation, { LockOrientations, Orientation }
  from '../../common/orientation/Orientation';
import Container, { Progress, TextHeader } from "../../common/Container";
import KaSignaturePad from "./KaSignaturePad";
import { useLingui } from "@lingui/react";
import { msg, Trans } from "@lingui/macro";
import KaSignatureOrientation from "./KaSignatureOrientation";

interface SignatureProps {
  stagedOrderId: string,
  progress?: Progress,
  signatureSubmitted: (emailTickets: boolean, userEmail?: string) => void,
  devToolItems?: React.ReactNode,
}

const Signature = (props: SignatureProps) => {
  const submitSignature = useSubmitSignature(props.stagedOrderId, {
    onSuccess: ({ emailTickets, userEmail }) =>
      props.signatureSubmitted(emailTickets, userEmail),
  });

  return <KaSignatureOrientation
    submitSignature={submitSignature}
    devToolItems={props.devToolItems} />
}

export default Signature;
